







import AbpBase from "@/lib/abpbase";
import { Component, Prop, Watch } from "vue-property-decorator";
import {
  GetAllUsers,
  QueryTeamUserList,
  SaveTeamUsers
} from "@/api/pdTeam/index";

/**
 * 团队成员管理
 */
@Component({
  components: {}
})
export default class TeamUser extends AbpBase {
  @Prop() currentTeam: any;
  loading: boolean = false;
  userList: any[] = [];
  targetKeys: any[] = [];
  queryCondition: any = {
    QueryString: "",
    TeamId: null
  };
  listStyle = {
    width: "400px",
    height: "780px"
  };

  @Watch("currentTeam", { immediate: true, deep: true })
  onTeamChanged() {
    if (this.currentTeam) {
      this.queryCondition.TeamId = this.currentTeam.id;
      this.getAllUsers();
    }
  }

  renderFormat = (item: any) => {
    return item.userName;
  };

  handleChange(newTargetKeys: any) {
    this.targetKeys = newTargetKeys;
  }

  filterMethod(data: any, query: any) {
    return data.userName.indexOf(query) > -1;
  }

  //读取本团队用户和未分配团队的用户
  async getAllUsers() {
    if (!this.currentTeam) {
      return;
    }
    let res = await GetAllUsers(this.currentTeam.id);
    let data = res.data;
    if (data) {
      //筛选出本团队用户
      let tmpList: any[] = [];
      data.forEach((item: any) => {
        item.key = item.userId;
        if (item.teamId == this.currentTeam.id) {
          tmpList.push(item.userId);
        }
      });
      this.userList = data;
      this.targetKeys = tmpList;
    }
  }

  async submit() {
    if (!this.currentTeam) {
      return;
    }
    let payload = {
      TeamId: this.currentTeam.id,
      UserList: []
    };
    this.targetKeys.forEach(userId => {
      payload.UserList.push(userId);
    });
    await SaveTeamUsers(payload);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/team/teamUser.vue